export const toHumanFormat = (date) => {
    if (!date) {
        return null;
    }
    return date.split('-').reverse().join('/');
};
export const createDateObject = (dateString) => {
    if (!dateString) {
        return null;
    }
    return new Date(dateString.split('/').reverse().join('/'));
};
export const formatDate = (date) => {
    if (!date) {
        return null;
    }
    const objDate = new Date(Number.parseFloat(date) * 1000);
    const day = objDate.getDate();
    const month = objDate.getMonth();
    const year = objDate.getFullYear();
    return `${day}/${month}/${year}`;
};
